module.exports = __webpack_public_path__ + "static/media/bloom15.6df57b49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blooming/bloom15.jpg
// module id = 631
// module chunks = 0